export default __webpack_public_path__ + "static/media/ser6.00228f04.svg";